import { memo, useState } from "react";

import INEGame from "./components/INE";
import GameDialog from "../../baseComponents/GameContainer/components/GameDialog";

import successPhase1Message from "../../assets/games/ValidarIdentidad2/success_phase1.png";
import successMessage from "../../assets/games/ValidarIdentidad2/success.png";
import errorMessage from "../../assets/games/ValidarIdentidad2/error.png";
import message from "../../assets/games/ValidarIdentidad2/message.png";
import PhotoGame from "./components/Photo";
import { useDispatch } from "react-redux";
import { addTime } from "../../redux/features/withdrawals/time";
import { changePhase } from "../../redux/features/fullWithdrawal/frustometro";

const Index = memo(({ visible, close, reset, pension }) => {
  const [phase, setPhase] = useState("INE");
  const [starGame, setStarGame] = useState(false);
  const [displayMessagePhase1, setDisplayMessagePhase1] = useState(false);
  const [success, setSuccess] = useState(null);
  const [resetGame, setResetGame] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(false);
  const [random, setRandom] = useState(Math.random());
  const dispatch = useDispatch();

  if (!visible) return null;

  if (displayMessagePhase1) {
    return (
      <GameDialog
        image={successPhase1Message}
        button="Continuar"
        close={() => {
          setPhase("Photo");
          setDisplayMessagePhase1(false);
          setStarGame(true);
          setResetGame(true);
        }}
        scale={1}
        alpha={1}
      />
    );
  }

  if (success === false) {
    return (
      <GameDialog
        image={errorMessage}
        button="Reintentar"
        close={() => {
          setSuccess(null);
          setResetGame(true);
        }}
        scale={1}
        alpha={1}
      />
    );
  }

  if (success === true) {
    return random < 0.5 ? (
      <GameDialog
        image={successMessage}
        button="Continuar"
        close={() => {
          dispatch(addTime(1));
          //setTimeout(close, 200);
          close();
        }}
        scale={1}
        alpha={1}
      />
    ) : (
      <GameDialog
        image={message}
        button="Continuar"
        close={() => {
          dispatch(addTime(120));
          //setTimeout(close, 200);
          close();
        }}
        scale={1}
        alpha={1}
      />
    );
  }

  return phase === "INE" ? (
    <INEGame
      reset={resetGame}
      onEndGame={(success) => {
        if (success) {
          setDisplayMessagePhase1(true);
        } else {
          dispatch(changePhase("angry"));
          setSuccess(success);
        }
      }}
    />
  ) : (
    <PhotoGame
      startGame={starGame}
      reset={resetGame}
      onEndGame={(success) => {
        let phase = random < 0.5 ? "neutral" : "frustrated";
        phase = success ? phase : "angry";
        setSuccess(success);
        dispatch(changePhase(phase));
      }}
    />
  );
});

export default Index;
